
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[[...slug]]",
      function () {
        return require("private-next-pages/info/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[[...slug]]"])
      });
    }
  